export function formatPercent(ratio: number | undefined, fractionDigits = 0): string {
  if (ratio == null) {
    return '—';
  }
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(ratio);
}
